import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", { d: "M12.905 15.6h-9.8c-.8 0-1.45-.65-1.45-1.45V8.59h-.65a.74.74 0 0 1-.69-.46c-.12-.28-.05-.6.16-.82l6.5-6.5c.27-.27.64-.42 1.03-.42s.75.15 1.02.43l6.5 6.5a.751.751 0 0 1-.53 1.28h-.65v5.56c0 .8-.65 1.45-1.45 1.45l.01-.01ZM2.725 7.17c.25.12.42.38.42.68v6.31c3.873-.077 4.234-.05 9.75-.05l-.05-6.26c0-.29.17-.55.42-.67l-5.3-5.3-5.24 5.29Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M8.001 11.517a.896.896 0 0 0 .896-.896c0 .018 0 .017-.006-.008a3.754 3.754 0 0 0-.135-.448c-.12-.336-.293-.745-.5-1.19a29.638 29.638 0 0 0-.255-.535 29.57 29.57 0 0 0-.254.535c-.207.445-.38.854-.5 1.19-.093.259-.125.4-.136.448-.005.025-.006.026-.006.008 0 .495.402.896.896.896Zm-.848-4.723c-.69 1.324-1.548 3.115-1.548 3.827a2.396 2.396 0 0 0 4.792 0c0-.712-.858-2.503-1.547-3.827l-.015-.03a53.19 53.19 0 0 0-.494-.925.385.385 0 0 0-.68 0 55.962 55.962 0 0 0-.508.955Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  o,
  n
];
function d(r, s) {
  return c(), t("svg", l, [...a]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
